import { Moon, Sun } from "lucide-react";
import { buttonVariants } from "@/components/ui/button";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import { TarefaNotificacoes } from "@/components/tarefa/notificacoes/TarefaNotificacoes";
import { ComunicadosBoundary } from "@/components/comunicados/ComunicadosBoundary";
import { ComunicadoSistemaSino } from "@/components/comunicados/ComunicadoSistemaSino";

interface HeaderActionsProps {
  theme: string;
  onToggleTheme: () => void;
}

export function HeaderActions({ theme: _theme, onToggleTheme }: HeaderActionsProps) {
  return (
    <div className="flex items-center gap-1">
      <ComunicadosBoundary>
        <ComunicadoSistemaSino />
      </ComunicadosBoundary>

      <TarefaNotificacoes />

      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger
            className={buttonVariants({
              variant: "ghost",
              size: "icon",
              className: "h-9 w-9 text-muted-foreground hover:text-foreground",
            })}
            onClick={onToggleTheme}
          >
            <Sun className="h-4 w-4 rotate-0 scale-100 transition-all dark:-rotate-90 dark:scale-0" />
            <Moon className="absolute h-4 w-4 rotate-90 scale-0 transition-all dark:rotate-0 dark:scale-100" />
            <span className="sr-only">Alternar tema</span>
          </TooltipTrigger>
          <TooltipContent>Alternar tema</TooltipContent>
        </Tooltip>
      </TooltipProvider>
    </div>
  );
}
